import Vue from 'vue';

// initial state
const state = {
  selectedClient: null,
  contacts: [],
  clients: [],
  metadata: {},
  providerContacts: {},
  products: {},
  types: [],
  searchTypes: [],
  customFieldGroups: {
    touristic_provider: [],
    destination: [],
  },
  typeCategories: [],
};

const mutations = {
  setTypes(currentState, types) {
    currentState.types = types;
  },
  setTypeCategories(currentState, categories) {
    currentState.typeCategories = categories;
  },
  setSearchTypes(currentState, searchTypes) {
    currentState.searchTypes = searchTypes;
  },
  setSelectedClient(currentState, client) {
    currentState.selectedClient = client;
  },
  setContacts(currentState, contacts = []) {
    currentState.contacts = contacts;
  },
  setClients(currentState, clients = []) {
    currentState.clients = clients;
  },
  setClient(currentState, newClient = null) {
    currentState.clients = currentState.clients.filter(it => it.id !== newClient.id);
    currentState.clients.push(newClient);
  },
  setContact(currentState, newContact = null) {
    currentState.contacts = currentState.contacts.filter(obj => obj.id !== newContact.id);
    currentState.contacts.push(newContact);
  },
  setProviderContacts(currentState, { providerId, contacts }) {
    Vue.set(currentState.providerContacts, providerId, contacts);
  },
  setSheets(currentState, sheets) {
    currentState.sheets = sheets;
  },
  setMetadata(currentState, { key, params }) {
    // const { size, start, count } = params;
    const newMeta = {};
    newMeta[key] = params;
    currentState.metadata = Object.assign(newMeta);
  },
  setClientProducts(currentState, { products, clientId }) {
    Vue.set(currentState.products, clientId, products);
  },
  editClient(currentState, { field, value }) {
    if (currentState.selectedClient === null) {
      currentState.selectedClient = {};
    }
    currentState.selectedClient[field] = value;
  },
  setDistinctValues(currentState, { column, values }) {
    currentState.distinctValues[column] = values;
  },
};

export { mutations, state };
